import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FullPageProgress from './FullPageProgress';
import { navigateToRestored, useRestoreLocation } from './useRestoreLocation';
import { usePreferredApp } from './usePreferredApp';

/**
 * The root path owns no UI: it decides which of the two apps you land in, and
 * where in it. Field-only roles (Mitarbeiter, Teamleitung (Junior)) always go
 * to Feldaufnahme; everyone else returns to whichever app they used last — and
 * in that app to the page they left off on (see useRestoreLocation).
 *
 * A DEFAULT, not a gate — a deep link never comes through here. What field-only
 * crew may open is decided at the office door itself (see RequireOffice).
 */
export default function RootRedirect() {
    const navigate = useNavigate();
    const target = useRestoreLocation(usePreferredApp());

    useEffect(() => {
        if (target) {
            navigateToRestored(navigate, target);
        }
    }, [target, navigate]);

    // Nothing of its own to show, in either state: this page is only ever on
    // screen for as long as the decision above takes.
    return <FullPageProgress />;
}
